import comp from '../components/barrel';
import listReturnState from '../js/listReturnState';

const EP = 'advisors/get-advisor-details';

const VIEW_ADVISOR_TABS = {
  VAd_Details: {
    html_text: 'VAd_Details',
    short_text: 'Details',
    activeTab: true,
    subMenu: [],
  },
  VAd_ContactReports: {
    html_text: 'VAd_ContactReports',
    short_text: 'Contact reports',
    activeTab: false,
    subMenu: [],
  },
  VAd_CommsLog: {
    html_text: 'VAd_CommsLog',
    short_text: 'Communication log',
    activeTab: false,
    subMenu: [],
  },
  VAd_WillsApplications: {
    html_text: 'VAd_WillsApplications',
    short_text: 'Wills/Applications',
    activeTab: false,
    subMenu: [],
  },
};

export default {
  tabsYN: 0,

  async prepare() {
    if (this.vars && this.vars.listRestore && this.vars.listRestore.advisor_uuid) {
      this.vars.advisor_uuid = this.vars.listRestore.advisor_uuid;
    }
    const advisor_uuid = this.vars && this.vars.advisor_uuid ? String(this.vars.advisor_uuid) : '';
    if (!advisor_uuid) return;
    this.recipe.methods.push(await O.mPOST(EP, {advisor_uuid}));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    this.tabs = VIEW_ADVISOR_TABS;
    try {
      const state = history.state ? JSON.parse(history.state) : {};
      state.tabs = VIEW_ADVISOR_TABS;
      history.replaceState(JSON.stringify(state), '', 'ViewAdvisor');
    } catch (e) {
      /* ignore */
    }

    const detailsRes = data[EP] || {};
    this.advisorDetails = detailsRes.status === 'OK' ? detailsRes.data || null : null;
    this.advisorDetailsError =
      detailsRes.status && detailsRes.status !== 'OK'
        ? (detailsRes.data && detailsRes.data.error) || 'Unable to load advisor details'
        : null;
    if (this.vars) {
      this.vars.target_user_uuid =
        (this.advisorDetails && this.advisorDetails.advisor_uuid) || this.vars.advisor_uuid || '';
    }

    const back = listReturnState.take('ViewAdvisor') || this.listReturnBack || {
      listPage: 'ManageAdvisors',
      state: {},
    };
    this.listReturnBack = back;
    const activeTab = (await comp.sideNav(this.tabs)) || 'VAd_Details';
    const backLabel = back.listPage === 'ViewAdvisorGroup' ? 'Back to advisor group' : 'Back to advisors';
    listReturnState.prependBackToSideNav(backLabel, back);
    await O.changeTab(activeTab, {
      advisor_uuid: this.vars && this.vars.advisor_uuid,
      advisor_user_id: this.advisorDetails && this.advisorDetails.h_user_id,
    });
  },
};
